import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  // 🔒 Iter47 — DO NOT inject the customer/staff `xch_token` on merchant-portal
  // routes (`/xpay/*`). Those use a separate `xpay_token` stamped by the
  // XPayPortal-local interceptor. Axios runs request interceptors in REVERSE
  // registration order (LIFO), so without this skip the default interceptor
  // (registered at module import) would OVERWRITE the merchant token set by
  // the portal interceptor (registered later in useEffect), bouncing every
  // logged-in merchant back to /login the moment the dashboard fetches data.
  // The `/admin/xpay/*` admin routes are intentionally not skipped — staff
  // managing merchants still authenticate with `xch_token`.
  const url = config.url || "";
  if (url.startsWith("/xpay/") || url.startsWith("xpay/")) {
    return config;
  }
  const token = localStorage.getItem("xch_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export const formatEUR = (n) =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(n || 0);

export const formatCrypto = (n, decimals = 6) => {
  if (!n && n !== 0) return "—";
  const abs = Math.abs(n);
  const d = abs < 1 ? 6 : abs < 100 ? 4 : 2;
  return Number(n).toLocaleString("en-IE", { maximumFractionDigits: d });
};

export const formatPct = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "0.00%";
  return `${n >= 0 ? "+" : ""}${n.toFixed(2)}%`;
};

export const ASSET_ICONS = {
  BTC: "#F7931A", ETH: "#627EEA", USDT: "#26A17B", USDC: "#2775CA",
  SOL: "#14F195", XRP: "#23292F", ADA: "#0033AD", DOGE: "#C2A633",
  MATIC: "#8247E5", DOT: "#E6007A",
};
